import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const ListPagination = (props) => {
  const {
    skip,
    limit,
    total,
    onChange = () => {},
    showTotal = true,
    className,
    size,
  } = props;
  const [input, setInput] = useState('');
  const pg = {
    total: Math.ceil(total / limit) || 0,
    current: skip / limit + 1,
  };
  const { t, i18n } = useTranslation();
  // buttons & inputs
  const chW = pg.current.toString().length;
  const prev = pg.current > 1;
  const next = pg.current < pg.total;

  const to = (page) => {
    if (Number.isNaN(parseInt(page, 10))) return;
    if (page > 0 && page <= pg.total) {
      onChange({ skip: limit * (page - 1) });
    }
  };

  useEffect(() => {
    setInput(pg.current);
  }, [pg.current]);

  return (
    <div className={`
      pagination
      ${size ? `pagination-${size}` : ''}
      ${className}
    `}>
      {pg.total > 1 && (
        <>
          <div
            className={`page-item${prev ? '' : ' disabled'}`}
            onClick={(evt) =>{ 
              evt.stopPropagation();
              evt.preventDefault();
              return to(pg.current - 1)
            }}
          >
            <a href="#" className="page-link">&lt;</a>
          </div>
          <div className="page-item">
            <div className={`
              input-group bg-white
              ${size ? `input-group-${size}` : ''}
            `}>
              <input
                className="
                  form-control bg-transparent
                  border-right-0 border-left-0
                "
                value={input}
                onChange={(e) => {
                  const { value } = e.target;

                  setInput(value);
                  to(value);
                }}
                onBlur={() => {
                  setInput(pg.current);
                }}
                style={{
                  width: `calc(${chW}ch + ${
                    {
                      sm: 1,
                      md: 1.5,
                      lg: 2,
                    }[size || 'md']
                  }rem)`,
                }}
              />
              <div className="input-group-append">
                <span
                  className="input-group-text bg-white pl-0 border-left-0"
                >
                  / {pg.total}
                </span>
              </div>
            </div>
          </div>
          <div
            className={`page-item${next ? '' : ' disabled'}`}
            onClick={(evt) =>{ 
              evt.stopPropagation();
              evt.preventDefault();
              return to(pg.current + 1)
            }}
          >
            <a href="#" className="page-link">&gt;</a>
          </div>
        </>
      )}
      {showTotal && (
        <div className="page-item disabled">
          <a className="page-link">
            {window.location.pathname.includes('/admin')
              ? t('Total')
              : '共計'} {total || 0}
          </a>
        </div>
      )}
    </div>
  );
};

export default ListPagination;
